import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ReviewsElement from "./ReviewsElement";
import { Rating } from "@mui/material";
import ShopButton from "./ShopButton";
import { useFirestore } from "../firebase/FirestoreContext";
import { collection, getDocs } from "firebase/firestore";
import { EnvContext } from "../context/EnvContext";
import config from "../config";
import { useModal } from "../context/ModalContext";
import { UserContext } from "../context/UserContext";

const ReviewList = ({ product }) => {
  const environment = useContext(EnvContext);
  const [reviews, setReviews] = useState(null);
  const db = useFirestore();
  const navigate = useNavigate();
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;
  const { setCurrentModal } = useModal();
  const { user } = useContext(UserContext);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const reviewsCollection = collection(db, `${collectionPath}Products/ProductsList/DataBase/${product?.id}/Reviews`);
        const reviewsSnapshot = await getDocs(reviewsCollection);

        const reviewsData = reviewsSnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((review) => !review.remove_review); // exclude removed reviews

        setReviews(reviewsData);
      } catch (error) {
        console.error("Error fetching reviews:", error);
        setReviews([]);
      }
    };

    fetchReviews();
  }, [db, product?.id, collectionPath]);

  const averageRating = product?.rating_initial.rating;
  const totalReviews = product?.rating_initial.voting;

  if (!reviews) {
    return <div>Loading reviews...</div>;
  }

  return (
      <div style={styles.reviewList}>
        <div style={styles.header}>
          <div style={styles.title}>Customer Reviews</div>
          <div style={styles.header.rating}>
            <div style={{ display: "flex", flexDirection: "row", fontSize: "1rem", fontWeight: "300", cursor: "pointer" }} onClick={() => {
                  // if user is logged in, then go to page review, if not show popup modal
                  if (!user) {
                    setCurrentModal("signUptoReview");
                  } else {
                    window.location.href = `/review-create/${product?.id}`;
                  }
                }} >
              <Rating value={parseFloat(averageRating)} readOnly precision={0.1} size="small" />
              <div style={{ margin: "5px 0 0 5px" }}>{averageRating} out of 5</div>
            </div>
          </div>
          <div style={{ fontSize: ".9rem", margin: "5px 0 0 0px" }}>{totalReviews} verified ratings</div>
        </div>

        {reviews.length === 0 ? (<div style={{ margin: "20px 0", color: "gray" }}>No reviews yet.</div>) : (
          <div>
            <div style={{ height: 15 }} />
            {reviews.map((review, index) => (
              <>
                <ReviewsElement key={index} {...review} productId={product?.id} reviewId={review.id} />
              </>
            ))}
            {reviews?.length > 1 && (
              <ShopButton
                text={"See More Reviews"}
                outlined
                containerStyles={{ width: "100%" }}
                buttonStyle={{ flex: 1 }}
                arrow={true}
                onClick={() => navigate(`/reviews/${product?.id}`)}
              />
            )}
          </div>
        )}
      </div>
    );
};

const styles = {
  reviewList: {
    padding: "20px 0",
  },
  title: {
    fontSize: "1.3rem",
    fontWeight: "800",
    display: "flex",
    color: "black",
    paddingBottom: 10,
  },
  header: {
    title: {
      fontSize: "1.15rem",
      fontWeight: "500",
      paddingBottom: 10,
    },
  },
};

export default ReviewList;
